import { GameStatues, IGameView } from "@grassrootly/api/entities";
import { GetGameViewByIdPayload } from "@grassrootly/api/gateways/game";
import server from "../Server";
import withErrorCheck from "../CheckError";

export const GetGameViewById = async (payload: GetGameViewByIdPayload): Promise<IGameView | null> => {
  // Fetch game data from the game_overview view
  const gameOverview = withErrorCheck(
    await server.from("game_overview").select("*").eq("game_id", payload.id)
  )[0];
  
  if (!gameOverview) {
    return null;
  }

  // Fetch attendance data from the game_attendance_overview view
  const order: any = { key: "player_attended", opts: { ascending: false, nullsFirst: false } };
  if (gameOverview.game_status === GameStatues.FINALIZED) {
    order.key = "player_experience_earned";
    order.opts = { ascending: false };
  }
  
  const attendanceData = withErrorCheck(
    await server
      .from("game_attendance_overview")
      .select("*")
      .eq("game_id", gameOverview.game_id || 0)
      .order(order.key, order.opts)
  );

  // Count players who voted
  const playersVotedCount = attendanceData.filter((attendance) => attendance.player_voted).length;

  // Fetch host_group_id and visitor_group_id from the Games table for ORGANIZATION_MATCH
  const gameDetails = withErrorCheck(
    await server
      .from("Games")
      .select("*")
      .eq("id", gameOverview.game_id)
      .single()
  );

  // Map the game_overview data to the IGameView interface
  return {
    game_id: gameOverview.game_id,
    group_name: gameOverview.group_name,
    group_id: gameOverview.group_id,
    group_logo: gameOverview.group_logo,
    game_type: gameOverview.game_type,
    game_status: gameOverview.game_status,
    game_datetime: gameOverview.game_datetime,
    game_location: gameOverview.game_location,
    game_notes: gameOverview.game_notes,
    host_team_name: gameOverview.host_team_name,
    visitor_team_name: gameOverview.visitor_team_name,
    host_team_logo: gameOverview.host_team_logo,
    visitor_team_logo: gameOverview.visitor_team_logo,
    host_group_id: (gameDetails as any)?.host_group_id || null,
    visitor_group_id: (gameDetails as any)?.visitor_group_id || null,
    game_created_at: gameOverview.game_created_at,
    group_created_at: gameOverview.group_created_at,
    season_information: gameOverview.season_information,
    organization_logo: gameOverview.organization_logo,
    host_score: gameOverview.host_score,
    visitor_score: gameOverview.visitor_score,
    attendees: attendanceData,
    players_voted_count: attendanceData.filter((attendance) => attendance.player_voted).length,
    playing_as_host: gameOverview.playing_as_host,
    game_season_id: gameOverview.game_season_id,
  };
};
